import { createStore } from 'jotai'

const globalStore = createStore()

export { globalStore }
